import { RankemPointsRules } from "model/PickemDetails/Rankem/PointsRules";
import { nonUndefined } from "Utility";
import { mapRankemColumns } from "./FsRankemColumns";
import { mapRankemPartialPoints } from "./FsRankemPartialPoints";
import { FsRankemPointsRules } from "db/model/pickemDetails/Rankem/FsRankemPointsRules";

export const mapRankemPointsRules = (
  fsModel: FsRankemPointsRules
): RankemPointsRules | undefined => {
  if (!fsModel.columns) {
    return undefined;
  }

  return {
    columns: mapRankemColumns(nonUndefined(fsModel.columns)),
    partialPoints: !!fsModel.partialPoints
      ? mapRankemPartialPoints(nonUndefined(fsModel.partialPoints))
      : undefined,
  };
};
